export const homeFaqData = [
  {
    name: "What types of real estate investments does AREL offer?",
    detail:
      "AREL offers various real estate investment opportunities, including residential, commercial, and rental properties. Investors can choose from direct property ownership, REITs, or fractional ownership options.",
    active: false,
  },
  {
    name: "How secure is investing with AREL?",
    detail:
      "AREL ensures investment security through thorough due diligence, legal verifications, and risk management strategies. Properties are vetted, and investment structures are designed to offer stable returns with minimal risks.",
    active: false,
  },
  {
    name: "What is AREL, and what services do you offer?",
    detail:
      "AREL is a real estate investment platform that provides property acquisition, management, and investment opportunities. Our services include property sourcing, legal documentation, and investment advisory.",
    active: false,
  },
  {
    name: "Can I schedule a visit to see a property before investing?",
    detail:
      "Yes, AREL allows investors to schedule property visits before making investment decisions. You can contact our team to arrange a viewing and get all necessary details about the property.",
    active: false,
  },
  {
    name: "How do I verify the legitimacy of a property before purchasing?",
    detail:
      "You can verify a property's legitimacy by reviewing its title documents, ownership history, and regulatory approvals. AREL provides full transparency and assists investors in legal due diligence.",
    active: false,
  },
  {
    name: "Does AREL offer financing options for property investments?",
    detail:
      "Yes, AREL provides financing options, including mortgage assistance and flexible payment plans, to make property investments more accessible.",
    active: false,
  },
];

export interface faqDataType {
  name: string;
  detail: string;
  active: boolean;
}
